import { Button, Flex, Space, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { BankReconciliationConnectShine } from '../../../../assets/images'
import { getImageClassName } from '../../../../utils/getClassName'
import { useInitiateShineConnection } from '../../hooks/useInitiateShineConnection'
import * as Styled from './styles'

export const ConnectShineBanner = (): ReactElement => {
  const { t } = useTranslation()
  const { initiateShineConnection } = useInitiateShineConnection()

  return (
    <Styled.ConnectShineBannerContainer>
      <Text variant="h2" weight="bold">
        {t('bank_connection.connect_account.shine_banner.title')}
      </Text>
      <Styled.ContentWrapper>
        <Flex flexDirection="column">
          <Space size="s8" />
          <Text>{t('bank_connection.connect_account.shine_banner.text')}</Text>
          <Styled.CtaWrapper>
            <Button size="sm" variant="onColor" color="success" onClick={initiateShineConnection}>
              {t('bank_connection.connect_account.shine_banner.cta')}
            </Button>
          </Styled.CtaWrapper>
        </Flex>
        <Styled.IllustrationContainer className={getImageClassName()}>
          <BankReconciliationConnectShine />
        </Styled.IllustrationContainer>
      </Styled.ContentWrapper>
    </Styled.ConnectShineBannerContainer>
  )
}
